// extracted by mini-css-extract-plugin
module.exports = {"span":"scrollUpButton_span__1fN2O"};